<template>
  <v-data-table
    :headers="headers"
    hide-actions
    :hide-heaers="!hasHeaders"
    class="w-100 skeleton-table"
    :items="items">
    <template slot="headers" slot-scope="props">
      <th v-for="column in columns" :key="`header-${column}`">
        <skeleton-box  :flat="true">
          <skeleton-line size="md">
          </skeleton-line>
        </skeleton-box>
      </th>
    </template>
    <template slot="items" slot-scope="props">
      <tr>
        <td v-if="isCustomerMovements" style="width: 250px;">
          <v-layout row wrap>
            <v-flex shrink>
              <skeleton-box :flat="true">
                <skeleton-avatar size="30px">
                </skeleton-avatar>
              </skeleton-box>
            </v-flex>
            <v-flex>
              <skeleton-box :flat="true">
                <skeleton-line size="md" class="mb-2">
                </skeleton-line>
                <skeleton-line size="sm">
                </skeleton-line>
              </skeleton-box>
            </v-flex>
          </v-layout>
        </td>
        <td v-for="column in columns" :key="`column-${column}`">
          <skeleton-box :flat="true">
            <skeleton-line size="md">
            </skeleton-line>
          </skeleton-box>
        </td>
        <td class="text-xs-center" v-if="hasBtn" style="width: 75px;">
          <skeleton-box :flat="true">
            <skeleton-avatar size="36px">
            </skeleton-avatar>
          </skeleton-box>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import SkeletonAvatar from '@/components/global/skeletons/Avatar';
import SkeletonLine from '@/components/global/skeletons/Line';
import SkeletonBox from '@/components/global/skeletons/SkeletonBox';

export default {
  components: {
    SkeletonAvatar,
    SkeletonLine,
    SkeletonBox,
  },
  props: {
    columns: {
      type: Number,
      default: 0,
    },
    isCustomerMovements: {
      type: Boolean,
      default: false,
    },
    hasBtn: {
      type: Boolean,
      default: false,
    },
    hasHeaders: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [
        {
          text: '',
          value: 1,
        },
        {
          text: '',
          value: 2,
        },
        {
          text: '',
          value: 3,
        },
        {
          text: '',
          value: 4,
        },
        {
          text: '',
          value: 5,
        },
      ],
      animate: false,
    };
  },
  computed: {
    headers() {
      const headers = [];
      if (this.hasHeaders) {
        headers.fill({
          text: '',
          value: '',
        }, 0, this.columns);
      }
      return headers;
    },
  },
  methods: {
    delay(index) {
      return `delay-${index}`;
    },
  },
};
</script>
<style scoped>
  .skeleton-table >>> .table {
    table-layout: fixed;
  }
  .skeleton-table >>> table.datatable.table tbody tr td {
    padding-right: 16px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/global/skeletons/TableSkeleton.vue